import { render } from "./PropriedadeAgricolaForm.vue?vue&type=template&id=5d6c1356"
import script from "./PropriedadeAgricolaForm.vue?vue&type=script&lang=js"
export * from "./PropriedadeAgricolaForm.vue?vue&type=script&lang=js"

import "./PropriedadeAgricolaForm.vue?vue&type=style&index=0&id=5d6c1356&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__